import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { ExternalLink } from "lucide-react";

const BLOG_URL = "https://sureraddawithsanchayeeta.blogspot.com";
const PAGE_URL = "https://sureraddawithsanchayeeta.in/blog";
const TITLE = "Blog — Surer Adda With Sanchayeeta";
const DESCRIPTION =
  "Stories, song notes, and booking guides from Sanchayeeta — Bengali singer for weddings, corporate events, and cultural shows across India.";

export const Route = createFileRoute("/blog")({
  head: () => ({
    meta: [
      { name: "robots", content: "index, follow" },
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      {
        name: "keywords",
        content:
          "Bengali singer booking, hire Bengali singer, wedding singer Kolkata, live performance singer India, Rabindra Sangeet singer, versatile singer for events, corporate event singer, Sanchayeeta Seal, Surer Adda blog",
      },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:type", content: "website" },
      { property: "og:url", content: PAGE_URL },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: TITLE },
      { name: "twitter:description", content: DESCRIPTION },
    ],
    links: [{ rel: "canonical", href: PAGE_URL }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Blog",
          name: "Surer Adda With Sanchayeeta — Blog",
          description: DESCRIPTION,
          url: PAGE_URL,
          inLanguage: ["en", "bn"],
          mainEntityOfPage: BLOG_URL,
          author: {
            "@type": "Person",
            name: "Sanchayeeta Seal",
            jobTitle: "Bengali Versatile & Live Performance Singer",
            url: "https://sureraddawithsanchayeeta.in/about",
          },
          publisher: {
            "@type": "Organization",
            name: "Surer Adda With Sanchayeeta",
            url: "https://sureraddawithsanchayeeta.in",
          },
        }),
      },
    ],
  }),
  component: BlogPage,
});

function BlogPage() {
  useEffect(() => {
    const t = setTimeout(() => {
      window.location.href = BLOG_URL;
    }, 1500);
    return () => clearTimeout(t);
  }, []);

  return (
    <main className="mx-auto flex min-h-[60vh] max-w-2xl flex-col items-center justify-center gap-5 px-6 py-16 text-center">
      <h1 className="font-script text-4xl text-primary sm:text-5xl">Surer Adda Blog</h1>
      <p className="text-muted-foreground">
        Stories, song notes, and booking guides from Sanchayeeta — a Bengali versatile & live
        performance singer for weddings, corporate events, and cultural shows. Taking you to the
        full blog now…
      </p>
      <Button asChild size="lg" className="bg-primary text-primary-foreground">
        <a href={BLOG_URL} target="_blank" rel="noopener noreferrer">
          Open Blog <ExternalLink className="ml-2 h-4 w-4" />
        </a>
      </Button>
    </main>
  );
}
